"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconImport = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M53.27 19.67H42V25h8.59v31.2H19.42V25H28v-5.33H16.73A2.69 2.69 0 0 0 14 22.35v36.54a2.69 2.69 0 0 0 2.69 2.69h36.58A2.69 2.69 0 0 0 56 58.89V22.35a2.69 2.69 0 0 0-2.73-2.68z"
  }), _react["default"].createElement("path", {
    d: "M37.69 4.76a2.69 2.69 0 0 0-5.38 0v33.49L28 33.94l-1.66-1.66a2.69 2.69 0 1 0-3.8 3.8l5.65 5.65 4.9 4.9a2.46 2.46 0 0 0 .43.34 2.82 2.82 0 0 0 2.93 0 2.46 2.46 0 0 0 .43-.34l4.9-4.9 5.65-5.65a2.69 2.69 0 0 0-3.8-3.8L42 33.94l-4.3 4.3z"
  })),
  height: undefined,
  width: undefined
});
IconImport.displayName = 'IconImport';
var _default = IconImport;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/import.js
// module id = 155
// module chunks = 0